import React, { useState, useEffect } from "react";
import {
	Box,
	Grid,
	TextField,
	Typography,
	Button,
} from "@mui/material";
import MapIcon from "@mui/icons-material/Map";
import MapModal from "../../../components/MapModal";

function AbaEmpresa({ dados, setDados }) {
	const [openMapModal, setOpenMapModal] = useState(false);

	useEffect(() => {
		if (!dados.latitude && !dados.longitude && !dados.cep) {
			const timer = setTimeout(() => {
				obterLocalizacaoAtual();
			}, 1000);
			return () => clearTimeout(timer);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const formatCpfCnpj = (value) => {
		const cleanValue = value.replace(/\D/g, "");

		if (cleanValue.length <= 11) {
			return cleanValue
				.replace(/(\d{3})(\d)/, "$1.$2")
				.replace(/(\d{3})(\d)/, "$1.$2")
				.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
		} else {
			return cleanValue
				.replace(/(\d{2})(\d)/, "$1.$2")
				.replace(/(\d{3})(\d)/, "$1.$2")
				.replace(/(\d{3})(\d)/, "$1/$2")
				.replace(/(\d{4})(\d{1,2})$/, "$1-$2");
		}
	};

	const handleChange = (field, value) => {
		setDados((prev) => ({
			...prev,
			[field]: value,
		}));
	};

	const handleCpfCnpjChange = (value) => {
		const formatted = formatCpfCnpj(value);
		handleChange("cpfCnpj", formatted);
	};

	const handleCepChange = async (cep) => {
		handleChange("cep", cep);
		const cepLimpo = cep.replace(/\D/g, "");

		if (cepLimpo.length === 8) {
			try {
				const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
				const data = await response.json();

				if (!data.erro) {
					handleChange("uf", data.uf);
					handleChange("cidade", data.localidade);
					handleChange("bairro", data.bairro);
					handleChange("logradouro", data.logradouro);

					if (data.localidade && data.uf) {
						buscarCoordenadasPorCidade(data.localidade, data.uf);
					}
				} else {
					alert("CEP não encontrado");
				}
			} catch (error) {
				console.error("Erro ao buscar CEP:", error);
				alert("Erro ao buscar CEP. Verifique sua conexão.");
			}
		}
	};

	const buscarCoordenadasPorCidade = async (cidade, uf) => {
		try {
			const response = await fetch(
				`https://nominatim.openstreetmap.org/search?city=${encodeURIComponent(cidade)}&state=${encodeURIComponent(uf)}&country=Brazil&format=json&limit=1`
			);
			const data = await response.json();

			if (data && data.length > 0) {
				handleChange("latitude", parseFloat(data[0].lat));
				handleChange("longitude", parseFloat(data[0].lon));
			}
		} catch (error) {
			console.error("Erro ao buscar coordenadas:", error);
		}
	};

	const handleOpenMap = () => {
		if (!dados.latitude && !dados.longitude) {
			obterLocalizacaoAtual();
		}
		setOpenMapModal(true);
	};

	const obterLocalizacaoAtual = () => {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					handleChange("latitude", position.coords.latitude);
					handleChange("longitude", position.coords.longitude);
				},
				(error) => {
					console.error("Erro ao obter localização:", error);
					if (!dados.latitude && !dados.longitude) {
						handleChange("latitude", -3.71839);
						handleChange("longitude", -38.5434);
					}
				}
			);
		}
	};

	const handleSaveCoordinates = (latitude, longitude) => {
		handleChange("latitude", latitude);
		handleChange("longitude", longitude);
	};

	return (
		<Box>
			<Grid container spacing={3}>
				<Grid size={{ xs: 12 }}>
					<Typography
						variant="subtitle1"
						sx={{ color: "#1a9e8f", fontWeight: 600, mb: 2, fontSize: "16px" }}
					>
						Dados do Cliente
					</Typography>
				</Grid>

				<Grid size={{ xs: 12, md: 6 }}>
					<TextField
						fullWidth
						label="Nome / Razão Social"
						value={dados.nome || ""}
						onChange={(e) => handleChange("nome", e.target.value)}
						required
						InputLabelProps={{ style: { fontSize: "15px" } }}
						inputProps={{ style: { fontSize: "15px" } }}
					/>
				</Grid>
				<Grid size={{ xs: 12, md: 6 }}>
					<TextField
						fullWidth
						label="Apelido / Nome Fantasia"
						value={dados.nomeFantasia || ""}
						onChange={(e) => handleChange("nomeFantasia", e.target.value)}
						InputLabelProps={{ style: { fontSize: "15px" } }}
						inputProps={{ style: { fontSize: "15px" } }}
					/>
				</Grid>

				<Grid size={{ xs: 12, md: 3 }}>
					<TextField
						fullWidth
						label="CPF / CNPJ"
						value={dados.cpfCnpj || ""}
						onChange={(e) => handleCpfCnpjChange(e.target.value)}
						required
						InputLabelProps={{ style: { fontSize: "15px" } }}
						inputProps={{
							style: { fontSize: "15px" },
							maxLength: 18
						}}
						placeholder="000.000.000-00"
					/>
				</Grid>
				<Grid size={{ xs: 12, md: 3 }}>
					<TextField
						fullWidth
						label="IE / RG"
						value={dados.ieRg || ""}
						onChange={(e) => handleChange("ieRg", e.target.value)}
						InputLabelProps={{ style: { fontSize: "15px" } }}
						inputProps={{ style: { fontSize: "15px" } }}
					/>
				</Grid>
				<Grid size={{ xs: 12, md: 3 }}>
					<TextField
						fullWidth
						label="E-mail"
						type="email"
						value={dados.email || ""}
						onChange={(e) => handleChange("email", e.target.value)}
						InputLabelProps={{ style: { fontSize: "15px" } }}
						inputProps={{ style: { fontSize: "15px" } }}
					/>
				</Grid>
				<Grid size={{ xs: 12, md: 3 }}>
					<TextField
						fullWidth
						label="Telefone"
						value={dados.telefone || ""}
						onChange={(e) => handleChange("telefone", e.target.value)}
						InputLabelProps={{ style: { fontSize: "15px" } }}
						inputProps={{ style: { fontSize: "15px" } }}
					/>
				</Grid>
				<Grid size={{ xs: 12, md: 3 }}>
					<TextField
						fullWidth
						label="Data de Entrada na Base"
						type="date"
						value={dados.dataEntradaBase || ""}
						onChange={(e) => handleChange("dataEntradaBase", e.target.value)}
						InputLabelProps={{ style: { fontSize: "15px" }, shrink: true }}
						inputProps={{ style: { fontSize: "15px" } }}
					/>
				</Grid>

				<Grid size={{ xs: 12 }}>
					<Typography
						variant="subtitle1"
						sx={{ color: "#1a9e8f", fontWeight: 600, mt: 1, mb: 2, fontSize: "16px" }}
					>
						Endereço
					</Typography>

					<Grid container spacing={3}>
						<Grid size={{ xs: 12, md: 2 }}>
							<TextField
								fullWidth
								label="CEP"
								value={dados.cep || ""}
								onChange={(e) => handleCepChange(e.target.value)}
								InputLabelProps={{ style: { fontSize: "15px" } }}
								inputProps={{ style: { fontSize: "15px" } }}
							/>
						</Grid>
						<Grid size={{ xs: 12, md: 1 }}>
							<TextField
								fullWidth
								label="UF"
								value={dados.uf || ""}
								onChange={(e) => handleChange("uf", e.target.value)}
								InputLabelProps={{ style: { fontSize: "15px" } }}
								inputProps={{ style: { fontSize: "15px" } }}
							/>
						</Grid>
						<Grid size={{ xs: 12, md: 5 }}>
							<TextField
								fullWidth
								label="Cidade"
								value={dados.cidade || ""}
								onChange={(e) => handleChange("cidade", e.target.value)}
								InputLabelProps={{ style: { fontSize: "15px" } }}
								inputProps={{ style: { fontSize: "15px" } }}
							/>
						</Grid>
						<Grid size={{ xs: 12, md: 4 }}>
							<TextField
								fullWidth
								label="Bairro"
								value={dados.bairro || ""}
								onChange={(e) => handleChange("bairro", e.target.value)}
								InputLabelProps={{ style: { fontSize: "15px" } }}
								inputProps={{ style: { fontSize: "15px" } }}
							/>
						</Grid>
						<Grid size={{ xs: 12 }}>
							<TextField
								fullWidth
								label="Logradouro"
								value={dados.logradouro || ""}
								onChange={(e) => handleChange("logradouro", e.target.value)}
								InputLabelProps={{ style: { fontSize: "15px" } }}
								inputProps={{ style: { fontSize: "15px" } }}
							/>
						</Grid>

						<Grid size={{ xs: 12, md: 4 }}>
							<TextField
								fullWidth
								label="Latitude"
								type="number"
								value={dados.latitude || ""}
								onChange={(e) => handleChange("latitude", e.target.value)}
								InputLabelProps={{ style: { fontSize: "15px" } }}
								inputProps={{ style: { fontSize: "15px" } }}
							/>
						</Grid>
						<Grid size={{ xs: 12, md: 4 }}>
							<TextField
								fullWidth
								label="Longitude"
								type="number"
								value={dados.longitude || ""}
								onChange={(e) => handleChange("longitude", e.target.value)}
								InputLabelProps={{ style: { fontSize: "15px" } }}
								inputProps={{ style: { fontSize: "15px" } }}
							/>
						</Grid>
						<Grid size={{ xs: 12, md: 4 }}>
							<Button
								fullWidth
								variant="outlined"
								startIcon={<MapIcon />}
								onClick={handleOpenMap}
								sx={{
									height: "48px",
									textTransform: "none",
									borderColor: "#d0d0d0",
									color: "#666",
									fontSize: "15px",
									"&:hover": {
										borderColor: "#1a9e8f",
										color: "#1a9e8f",
										bgcolor: "rgba(23, 162, 184, 0.04)",
									},
								}}
							>
								Selecionar no Mapa
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>

			<MapModal
				open={openMapModal}
				onClose={() => setOpenMapModal(false)}
				initialLat={dados.latitude}
				initialLon={dados.longitude}
				onSave={handleSaveCoordinates}
			/>
		</Box>
	);
}

export default AbaEmpresa;
